
















































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { AdminSendMessageDto, NanudaUserDto } from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import NanudaUserService from '../../../services/nanuda-user.service';
import SmsService from '../../../services/sms.service';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'NanudaUserDetail',
})
export default class NanudaUserDetail extends BaseComponent {
  private nanudaUserDto = new NanudaUserDto(BaseUser);
  private adminSendMessageDto = new AdminSendMessageDto();

  // 상세 보기
  findOne(id) {
    NanudaUserService.findOne(id).subscribe(res => {
      if (res) {
        this.nanudaUserDto = res.data;
      }
    });
  }

  // send message to user
  sendMessage() {
    this.adminSendMessageDto.phone = this.nanudaUserDto.phone;
    SmsService.sendMessage(this.adminSendMessageDto).subscribe(res => {
      if (res) {
        this.adminSendMessageDto = new AdminSendMessageDto();
        toast.success('문자가 발송 되었습니다.');
      } else {
        return;
      }
    });
  }

  // clear out send message
  clearOutSendMessage() {
    this.adminSendMessageDto = new AdminSendMessageDto();
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
